import { render } from "./NUIButton.vue?vue&type=template&id=49a17664&scoped=true"
import script from "./NUIButton.vue?vue&type=script&lang=js"
export * from "./NUIButton.vue?vue&type=script&lang=js"

import "./NUIButton.vue?vue&type=style&index=0&id=49a17664&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49a17664"]])

export default __exports__